import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    displayableCashback,
    hasCashback,
    isMultiDiscount,
    isMultiDiscountOffline,
    hasCashbackOffline,
    renderPluralConditional,
    hasEbon
} from '../../services/partner/utils';

class CashbackBlocPartenaireComponent extends React.Component {
    pluralCondFunc = mdd => mdd && (mdd.fixed > 1 || mdd.percent > 1);

    renderJusqua = (partner, isOffline, i18n) =>
        (!isOffline && isMultiDiscount(partner)) ||
        (isOffline && isMultiDiscountOffline(partner)) ? (
            <div className="jusqua small">{i18n.jusqua}</div>
        ) : (
            <div className="jusqua small">&nbsp;</div>
        );

    renderDisplayCashback = (percent, fixed) => (
        <strong>{`${displayableCashback(percent, fixed)} `}</strong>
    );

    renderCashback = discount => {
        const { percent, fixed } = discount;
        return this.renderDisplayCashback(percent, fixed);
    };

    renderInsteadOf = (i18n, discount) => {
        const { initialPercent, initialFixed } = discount;

        if (initialPercent > 0 || initialFixed > 0) {
            return (
                <div className="small aulieu">
                    {`${i18n.aulieude} ${displayableCashback(initialPercent, initialFixed)}`}
                </div>
            );
        }
        return <div className="small aulieu">&nbsp;</div>;
    };

    renderEbonCashbackCumul = () => {
        const { ebonCbCumulable } = this.props;
        return ebonCbCumulable;
    };

    renderNoCashback = (i18n, cssClassContainer) => (
        <div className={`${cssClassContainer} flex-container-v`}>
            <div className="small nocashback">{i18n.pasdecashbackencemoment}</div>
        </div>
    );

    renderConditional = (partner, i18n, cssClassContainer, isOffline, discount, isEbon) => {
        if (
            (partner && hasCashback(partner) && !isOffline) ||
            (hasCashbackOffline(partner) && isOffline) ||
            (hasEbon(partner) && isEbon)
        ) {
            const mostDisplayableDiscount = isOffline
                ? partner.mostDisplayableDiscountOffline
                : isEbon
                ? {
                      fixed: partner.ebonDiscount.cashback.fixed.value,
                      percent: partner.ebonDiscount.cashback.percent.value,
                      initialPercent: partner.ebonDiscount.cashback.percent.initialValue
                  }
                : partner.mostDisplayableDiscountOnline;
            const forcedDiscount =
                !!discount && discount.partnerId === partner.id && discount.cashback;
            const displayableDiscount = forcedDiscount ? forcedDiscount : mostDisplayableDiscount;

            return (
                <div className={`${cssClassContainer}`}>
                    {!isEbon && this.renderJusqua(partner, isOffline, i18n)}
                    <p className="valeur">
                        {this.renderCashback(displayableDiscount)}
                        <span>
                            {renderPluralConditional(i18n.rembourse, () =>
                                this.pluralCondFunc(displayableDiscount)
                            )}
                        </span>
                    </p>

                    {isEbon && <span className="immediately">{i18n.IMMEDIATELY}</span>}
                    {isEbon && this.renderInsteadOf(i18n, displayableDiscount)}
                    {isEbon
                        ? this.renderEbonCashbackCumul()
                        : this.renderInsteadOf(i18n, displayableDiscount)}
                </div>
            );
        } else {
            return this.renderNoCashback(i18n, cssClassContainer);
        }
    };

    render() {
        const { i18n, partner, cssClassContainer, isOffline, discount, isEbon } = this.props;
        return this.renderConditional(
            partner,
            i18n,
            cssClassContainer,
            isOffline,
            discount,
            isEbon
        );
    }
}

CashbackBlocPartenaireComponent.propTypes = {
    partner: PropTypes.object.isRequired,
    i18n: PropTypes.object.isRequired,
    cssClassContainer: PropTypes.string.isRequired,
    isOffline: PropTypes.bool,
    isEbon: PropTypes.bool,
    ebonCbCumulable: PropTypes.object,
    discount: PropTypes.object
};

const mapStateToProps = state => ({
    i18n: state.i18n.feature.partenaire
});

export default connect(mapStateToProps)(CashbackBlocPartenaireComponent);



// WEBPACK FOOTER //
// ./src/components/partner/CashbackBlocPartenaireComponent.js